import type { SpotMineResponse } from '../../types/api';

interface Props {
  spots: SpotMineResponse[];
  activeId: number;
  onSelect: (id: number) => void;
}

export function TabsRow({ spots, activeId, onSelect }: Props) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {spots.map((spot) => (
        <button
          key={spot.id}
          onClick={() => onSelect(spot.id)}
          className={[
            'shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap',
            spot.id === activeId
              ? 'bg-teal-600 dark:bg-teal-500 text-white'
              : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700',
          ].join(' ')}
        >
          {spot.name}
        </button>
      ))}
    </div>
  );
}
